import Simple3DPie from './Simple3DPie';
import { CustomerTypeStat } from '../../types';

interface CustomerTypePieChartProps {
  data: CustomerTypeStat[];
  onCustomerTypeClick?: (customerType: string) => void;
}

const COLORS = [
  '#FF6B6B',  // Bright red
  '#4ECDC4',  // Bright teal
  '#45B7D1',  // Bright blue
  '#96CEB4',  // Bright mint
  '#FFEAA7',  // Bright yellow
  '#DDA0DD',  // Bright purple
  '#98D8C8',  // Bright seafoam
  '#F7DC6F'   // Bright gold
];

export const CustomerTypePieChart = ({ data, onCustomerTypeClick }: CustomerTypePieChartProps) => {
  // Filter out QA data and transform to match Simple3DPie format
  const filteredData = data.filter(item => item.type !== 'QA');
  const pieData = filteredData.map((item, index) => ({
    label: item.type,
    value: item.sites,
    color: COLORS[index % COLORS.length]
  }));

  return (
    <Simple3DPie
      data={pieData}
      innerRadius={50}   // Reduced from 70
      outerRadius={85}   // Reduced from 120
      thickness={15}     // Reduced from 18
      showPercent
      onSliceClick={onCustomerTypeClick}
    />
  );
};